import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MpBookmark } from "../../common/bookmark.js";
import { MultiGLightbox } from "../../common/image_gallery.js";
import { mbSocialSharing, socialSharing } from "../../common/sharing.js";
import { yieldToMainBackground } from "../../common/utils.js";
import { MpVideoPlayer } from "../../common/video_player.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const multiJWP = new MpVideoPlayer();
	multiJWP.init().then((is_ready) => {
		// Lightbox tag galleria associata
		const gallery_data = document.querySelector("#_gallery-section");
		if (gallery_data) {
			const main_gallery = new MultiGLightbox({
				url: gallery_data.dataset.mainGalleryUrl,
				per_page: 20,
				selector: gallery_data.dataset.gallerySelector,
			});
		}

		// VIDEO SLOT
		if (document.querySelector("#_video_slot")) {
			for (const el of document.querySelectorAll(
				".video-grid__item:not(#_video_slot) a",
			)) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					const target = event.currentTarget;

					// remove current player
					multiJWP.destroyPlayer("_video_container");

					if (!!document.querySelector("#_video_container") === false) {
						// load new player
						const container = document.createElement("div");
						container.id = "_video_container";
						document
							.querySelector("#_video_slot .embed-responsive-item")
							.appendChild(container);
					}
					if (is_ready) {
						yieldToMainBackground().then(() => {
							multiJWP.setupPlayer(
								"_video_container",
								target.dataset.video_uid,
								{
									is_youtube: target.dataset.is_youtube,
									noads: target.dataset.no_ads,
									article_url: target.dataset.video_article,
									is_downloadable: true,
								},
							);
						});
					}

					// update data
					const video_div = document.querySelector("#_video_container");
					video_div.dataset.video_id = target.dataset.video_id;
					video_div.dataset.video_uid = target.dataset.video_uid;
					document
						.querySelector("#_video_slot")
						.querySelector("h2").textContent = target.dataset.name;
					for (const video of document.querySelectorAll(".video-grid__item")) {
						video.classList.remove("active");
					}
					target.parentNode.classList.add("active");
				});
			}
		}

		// SOCIAL SHARE
		if (document.querySelector("#social-share")) {
			const x_text = document.querySelector("#social-share .X").dataset.text;
			const fb = new socialSharing(
				document.querySelector("#social-share .facebook"),
				{ kind: "facebook" },
			);
			const x = new socialSharing(document.querySelector("#social-share .X"), {
				kind: "x",
				title: x_text,
				suffix: " via @Multiplayerit",
			});
			const tg = new socialSharing(
				document.querySelector("#social-share .telegram"),
				{ kind: "telegram" },
			);
			const wa = new socialSharing(
				document.querySelector("#social-share .whatsapp"),
				{ kind: "whatsapp" },
			);
		}
		const mb_share = document.querySelector("#_share-mb");
		if (mb_share) {
			mb_share.addEventListener("click", (event) => {
				event.preventDefault();
				mbSocialSharing(mb_share);
			});
		}

		// BOOKMARKS
		const tag_container = document.querySelector("#_tag_container");
		if (tag_container.dataset.ct && tag_container.dataset.id) {
			fetch(
				`/misc/bookmarks_and_vote/${tag_container.dataset.ct}/${tag_container.dataset.id}/`,
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
					cache: "no-cache",
				},
			)
				.then((response) => response.json())
				.then((data) => {
					document.querySelector("#_tag_bookmarks").innerHTML =
						data.follow_bookmark_form;
					init_tag_bookmarks();
				})
				.catch((error) => {
					console.warn(error);
				});
		}

		// Paginazione
		endlessPaginate({
			moreSelector: "span.endless_more",
			moreSelectorDataUrl: "data-more",
		});
	});
});

function init_tag_bookmarks() {
	const tag_follow = new MpBookmark(document.querySelector("#_tag_bookmarks"), {
		form: document.querySelector("#_tag_bookmarks .bookmarks_form"),
		message: document.querySelector("#_tag_bookmarks .tab_label"),
		message_on: "Non seguire",
		message_off: "Segui",
	});
}
